import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Grid,
  Button,
  Text,
  Container,
  Heading,
  useColorModeValue,
  Icon,
  HStack,
  useToast,
} from '@chakra-ui/react';
import { FaArrowLeft, FaPlay } from 'react-icons/fa';
import { imageDatabase } from '../data/imageDatabase';

const CategoriesPage = () => {
  const navigate = useNavigate();
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const toast = useToast();
  const [selectedCategories, setSelectedCategories] = useState([]);

  const toggleCategory = (categoryId) => {
    setSelectedCategories(prev => {
      if (prev.includes(categoryId)) {
        return prev.filter(id => id !== categoryId);
      }
      return [...prev, categoryId];
    });
  };

  const handleStartGame = () => {
    if (selectedCategories.length === 0) {
      toast({
        title: "No categories selected",
        description: "Please select at least one category",
        status: "warning",
        duration: 2000,
      });
      return;
    }
    navigate(`/play?categories=${selectedCategories.join(',')}`);
  };

  return (
    <Box minH="100vh" position="relative" pb="80px">
      <Container maxW="container.md" centerContent py={8}>
        <VStack spacing={8} width="100%">
          <Box width="100%">
            <Button
              leftIcon={<Icon as={FaArrowLeft} />}
              variant="ghost"
              onClick={() => navigate('/')}
              mb={4}
            >
              Back to Home
            </Button>
            <Heading
              as="h1"
              size="xl"
              textAlign="center"
              mb={4}
            >
              Select Categories
            </Heading>
            <Text textAlign="center" color="gray.500">
              Choose one or more categories to combine
            </Text>
          </Box>

          <Grid
            templateColumns="repeat(3, 1fr)"  // Always 3 columns
            gap={6}
            width="100%"
          >
            {Object.entries(imageDatabase).map(([id, category]) => (
              <Box
                key={id}
                bg={bgColor}
                p={6}
                borderRadius="xl"
                boxShadow="md"
                textAlign="center"
                transition="transform 0.2s"
                _hover={{ transform: 'scale(1.02)' }}
                cursor="pointer"
                onClick={() => toggleCategory(id)}
                position="relative"
                border={selectedCategories.includes(id) ? "3px solid" : "none"}
                borderColor="blue.500"
              >
                <Text fontSize="4xl" mb={2}>
                  {category.icon}
                </Text>
                <Heading size="md" mb={2}>
                  {category.name}
                </Heading>
                <Text color="gray.500">
                  {category.images.length} items
                </Text>
              </Box>
            ))}
          </Grid>
        </VStack>
      </Container>

      <Box
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        p={4}
        bg={useColorModeValue('white', 'gray.800')}
        boxShadow="0 -2px 10px rgba(0,0,0,0.1)"
        zIndex={10}
      >
        <Container maxW="container.md">
          <HStack justify="space-between" align="center">
            <Text>
              {selectedCategories.length} {selectedCategories.length === 1 ? 'category' : 'categories'} selected
            </Text>
            <Button
              colorScheme="blue"
              size="lg"
              onClick={handleStartGame}
              leftIcon={<Icon as={FaPlay} />}
              isDisabled={selectedCategories.length === 0}
            >
              Start Game
            </Button>
          </HStack>
        </Container>
      </Box>
    </Box>
  );
};

export default CategoriesPage; 